import { render } from "./NavgatorDk.vue?vue&type=template&id=d43d6862"
import script from "./NavgatorDk.vue?vue&type=script&lang=js"
export * from "./NavgatorDk.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__